export enum ECaptchaField {
  CAPTCHA_CONTAINER = "CAPTCHA_CONTAINER",
  ERROR_LIST_ELEMENTS = "ERROR_LIST_ELEMENTS",
  CAPTCHA_HASH = "CAPTCHA_HASH",
  CAPTCHA_IMAGE = "CAPTCHA_IMAGE",
  CAPTCHA_RESULT = "CAPTCHA_RESULT",
  REFRESH = "REFRESH",
}
